import PropTypes from 'prop-types'
import React, { Component } from 'react'
import AsyncSelect from 'react-select/lib/Async'
import Browser from '../../services/Browser'
import HigherOrderField from './higher-order-field.component'
import { selectStyles } from './styles/select.style'
import { StorageService } from '../../services/storage.service'
import { isMobile } from './../../helpers/window.helper'
import scrollIntoView from 'scroll-into-view-if-needed'

class BaseAsyncSelectField extends Component {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
		this.selectRef = React.createRef()
		this.state = { value: undefined, isLoading: false, inputValue: '' }
	}

	handleChange = (value) => {
		this.setState({ value }, () => {
			const { id, onChange, onValueChange } = this.props
			const newValue = !!value ? value.value : ''
			onChange(id, newValue)
			onValueChange && onValueChange(newValue)
		})
	}

	handleBlur = () => {
		const { id, onBlur } = this.props
		onBlur(id, true)
	}

	getOption = (opt) => {
		const { inputValue } = this.state
		const { loadOptions, placeholder } = this.props
		return new Promise((resolve) => {
			loadOptions(inputValue, (options) => {
				resolve(
					(options && options.find((o) => o.value == opt)) || {
						value: '',
						label: placeholder || 'Selecione ...',
					}
				)
			})
		})
	}

	componentDidMount() {
		const { value: formikValue, defaultValue } = this.props;
		
		if (!formikValue && defaultValue) {
			this.setState({ value: defaultValue });
		} else if (!defaultValue || defaultValue.value !== formikValue) {
			this.getOption(formikValue).then((value) => this.handleChange(value));
		}
	}
	
	componentWillReceiveProps(nextProps) {
		const { value: currentOption } = this.state;
		const { value: formikValue, defaultValue } = nextProps;
	
		if (
			currentOption === undefined ||
			(formikValue || '') !== (!!currentOption ? currentOption.value : '') ||
			(defaultValue && defaultValue.value !== (currentOption ? currentOption.value : ''))
		) {
			if (defaultValue) {
				this.setState({ value: defaultValue });
			} else {
				this.getOption(formikValue).then((value) => this.handleChange(value));
			}
		}
	}

	scrollOrigin = (position) => {
		let originElem = document.getElementById('select-origin')
		originElem = originElem.parentElement

		scrollIntoView(originElem, {
			behavior: 'smooth',
			block: position,
			scrollMode: 'always',
		})
	}

	scrollDestination = (position) => {
		let destinationElem = document.getElementById('select-destination')

		scrollIntoView(destinationElem, {
			behavior: 'smooth',
			block: position,
			scrollMode: 'always',
		})
	}

	render() {
		const {
			id,
			icon,
			loadOptions,
			placeholder,
			defaultValue,
			defaultOptions,
			disabled,
		} = this.props

		const { value, isLoading } = this.state

		const isIE = Browser.isIE()

		if (id === 'origin' && value != undefined)
			if (value.value != '') StorageService.lastOrigin.set(value)

		if (id === 'destination' && value != undefined)
			if (value.value != '') StorageService.lastDestination.set(value)
		return (
			<HigherOrderField
				full
				asyncSelect
				ref={this.elementRef}
				innerRef={this.elementRef}
				{...this.props}>
				<AsyncSelect
					isDisabled={disabled}
					value={value || ''}
					isLoading={isLoading}
					styles={selectStyles}
					onBlur={this.handleBlur}
					loadOptions={loadOptions}
					innerRef={this.selectRef}
					defaultValue={defaultValue}
					onMenuScrollToBottom={isIE}
					onChange={this.handleChange}
					backspaceRemovesValue={true}
					menuShouldBlockScroll={isIE}
					className={icon ? 'with-icon' : ''}
					loadingMessage={() => 'Carregando ...'}
					menuPosition={isIE ? 'fixed' : 'absolute'}
					placeholder={placeholder || 'Selecione...'}
					defaultOptions={
						Array.isArray(defaultOptions) ? defaultOptions : []
					}
					onInputChange={(data) => {
						this.setState({ inputValue: data, isLoading: true })
					}}
					noOptionsMessage={() => (
						<div style={{ fontSize: '16px', cursor: 'default' }}>
							Nenhuma opção para pesquisa
						</div>
					)}
					onMenuOpen={() => {
						const selects = [
							...document.querySelectorAll('[id^="field-"]'),
						]

						selects.forEach((elem) => {
							if (elem.id != `field-${id}`) {
								elem.style.zIndex = 0
							}
						})

						if (isMobile()) {
							if (id === 'origin') this.scrollOrigin('start')
							else if (id === 'destination')
								this.scrollDestination('start')
						}
					}}
					onMenuClose={() => {
						const selects = [
							...document.querySelectorAll('[id^="field-"]'),
						]

						selects.forEach((elem) => {
							elem.style.zIndex = 'auto'
						})

						if (isMobile()) {
							if (id === 'origin') this.scrollOrigin('center')
							else if (id === 'destination')
								this.scrollDestination('center')
						}
					}}
				/>
			</HigherOrderField>
		)
	}
}

BaseAsyncSelectField.propTypes = {
	id: PropTypes.string.isRequired,
}

export default BaseAsyncSelectField
